import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SplashOverlay = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 800);
    return () => clearTimeout(t);
  }, [location.pathname]);

  if (!visible) return null;

  const isBar = location.pathname.startsWith("/bar");
  const isCuisine = location.pathname.startsWith("/cuisine");
  const variant = isBar
    ? {
        title: "Bienvenue dans le KDS Bar",
        subtitle: "Service rafraîchi et réactif",
        accentFrom: "#ffb800",
        accentTo: "#ff9f43",
        tag: "KDS Bar",
      }
    : isCuisine
      ? {
          title: "Bienvenue dans le KDS Cuisine",
          subtitle: "Une expérience particulière vous y attend",
          accentFrom: "#ffb800",
          accentTo: "#ff9f43",
          tag: "KDS Cuisine",
        }
      : {
          title: "Bienvenue dans MOO Sync",
          subtitle: "Connexion à votre espace",
          accentFrom: "#ffb800",
          accentTo: "#ff9f43",
          tag: "MOO Sync",
        };

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center overflow-hidden"
      style={{ background: "linear-gradient(135deg,#040b1b,#0b152d)" }}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-[-10%] right-[-10%] w-64 h-64 rounded-full blur-3xl opacity-25"
          style={{ background: variant.accentFrom }}
        />
        <div
          className="absolute bottom-[-15%] left-[-15%] w-[28rem] h-[28rem] rounded-full blur-3xl opacity-20"
          style={{ background: variant.accentTo }}
        />
        <div className="absolute inset-0 bg-white/5" />
      </div>
      <div className="relative z-10 max-w-md w-full bg-white/5 border border-white/10 rounded-3xl p-7 shadow-2xl shadow-black/30 backdrop-blur text-center">
        <div className="flex flex-col items-center space-y-3">
          <div className="h-16 w-16 rounded-2xl bg-white/10 border border-white/10 flex items-center justify-center shadow-lg shadow-black/30">
            <img src="/moo-sync-insigne-logo.png" alt="MOO Sync" className="h-10 w-10 object-contain" />
          </div>
          <div className="space-y-1">
            <p className="text-[11px] uppercase tracking-[0.28em] text-amber-300">
              {variant.tag}
            </p>
            <h1 className="text-2xl font-bold text-white">{variant.title}</h1>
          </div>
          <p className="text-white/80 text-sm">{variant.subtitle}</p>
          <p className="text-white/70 text-sm">Patientez juste quelques secondes…</p>
          <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden mt-2">
            <div
              className="h-full w-1/3 rounded-full animate-[splashSlide_1.4s_ease-in-out_infinite]"
              style={{
                background: `linear-gradient(90deg, ${variant.accentFrom}, ${variant.accentTo})`,
              }}
            />
          </div>
        </div>
      </div>
      <style>{`
        @keyframes splashSlide {
          0% { transform: translateX(-50%); }
          50% { transform: translateX(130%); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

export default SplashOverlay;
